<template>
  <O3D>
    <slot></slot>
  </O3D>
</template>

<script>
import { O3DG2 } from '../../../Reusable/O3DG2'
import { loadGLTF } from '../../../Reusable/loadGLTF'
import { Color } from 'three'
// import { loadTexture } from '../../../Reusable/loadTexture'
// import { MeshMatcapMaterial } from 'three'
// import { BoxBufferGeometry, MeshBasicMaterial, Mesh } from 'three'
export default {
  mixins: [O3DG2],
  data () {
    return {
      controls: false
    }
  },
  async mounted () {
    this.modelURL = require('file-loader!./glb/hospital-short.glb')
    let gltf = await loadGLTF(this.modelURL)

    gltf.scene.traverse((item) => {
      if (item.isMesh) {
        item.geometry.scale(20, 20, 20)
        if (item.material.name.indexOf('light') !== -1) {
          let color = new Color('#ffffff')
          let r = Math.random()
          this.onLoop(() => {
            let time = window.performance.now() * 0.001
            item.material.emissive = color.setHSL((time + r) % 1, 0.75, 0.5)
          })
        } else {
          // let matcapURL = require('../../../GLContent/Beauty/matcap/silver.png')
          // loadTexture(matcapURL).then((tex) => {
          //   let matcapMaterial = new MeshMatcapMaterial({
          //     matcap: tex
          //   })
          //   item.material = matcapMaterial
          // })
          if (this.ctx.matcap && this.ctx.matcap.silver) {
            item.material = this.ctx.matcap.silver
          }
        }
      }
    })
    this.o3d.add(gltf.scene)
  }
}
</script>

<style>

</style>